import { ReactNode } from "react";
import DisplayPicture from "./DisplayPic"
import FallBackUserDiv from "./FallBackUserDiv";

interface UserImgComponentProps {
    computedProfileURL?: string;
    altText?: string;
    squircle?: boolean;
    children?: ReactNode,
    size?: "lg" | "sm" | "mini";
    initials?: string
}

 const UserImgComponent =  ({ computedProfileURL, size='sm', squircle, altText, children, initials }: UserImgComponentProps) =>  computedProfileURL ?  <DisplayPicture
    altText={altText || "User Picture"}
    size={size}
    squircle={squircle}
    children={children}
    imageSource={computedProfileURL || ''}
  /> : <FallBackUserDiv size="base"     children={children}
  initials={initials}/>

export default UserImgComponent;